import * as React from 'react';

import {
  IconCar16,
  IconWalk16,
  IconMetroMsk16,
  IconMetroSam16,
  IconMetroNN16,
  IconMetroKzn16,
  IconMetroNovosib16,
  IconMetroEkb16,
  IconMetroSpb16,
} from '@cian/ui-kit';
import { IIconProps } from '@cian/ui-kit/icons/internal';

import { TTransportType, TUndergroundType } from '../../types/subway';

export const transportIconMap: Record<TTransportType, React.FC> = {
  walk: IconWalk16,
  transport: IconCar16,
};

export const metroIconMap: Record<TUndergroundType, React.FunctionComponent<IIconProps>> & {
  default: React.FunctionComponent<IIconProps>;
} = {
  spb: IconMetroSpb16,
  mow: IconMetroMsk16,
  ekb: IconMetroEkb16,
  kzn: IconMetroKzn16,
  nsk: IconMetroNovosib16,
  nn: IconMetroNN16,
  smr: IconMetroSam16,
  default: IconMetroMsk16,
};
